import React, { useEffect } from 'react';
import { useLandingBrand } from './useLanding';
import Nav from './sections/Nav';
import Footer from './sections/Footer';
import './landing.css';

/*
 * Shared chrome for the marketing sub-pages (About, Contact, Changelog, legal).
 * Reuses the landing's .ftv2 nav + footer so the whole marketing surface feels
 * like one site. Each page supplies its own <SEO> in `children`.
 */
export default function MarketingPage({ children, wide = false }) {
  const brand = useLandingBrand();
  const rootStyle = brand.accent
    ? { '--orange': brand.accent, '--orange-dim': brand.accent }
    : undefined;

  // Sub-pages always open at the top.
  useEffect(() => { window.scrollTo(0, 0); }, []);

  return (
    <div className="ftv2" style={rootStyle}>
      <Nav brand={brand} />
      <div className={`ft-page${wide ? ' wide' : ''}`}>
        {children}
      </div>
      <Footer brand={brand} />
    </div>
  );
}
